<template>
  <div class='teacher'>
    <div class='ly-card'>
      <el-button type='primary' size='medium' @click.native='() => exportExcel()'>导出</el-button>
      <el-button type='primary' size='medium' @click.native='() => exportExcel(selection)' :disabled='!selection.length'
      >导出勾选
      </el-button
      >
      <el-button size='medium' @click.native='dialogVisible = true'>显示列名</el-button>
      <el-popover
        placement='bottom-start'
        width='740'
        trigger='click'
        class='m-l-10 m-r-10'
        :visible-arrow='false'
        v-model='searchVisible'
      >
        <div class='high-search'>
          <ly-form
            class='ly-form'
            :formConfig='searchFormConfig'
            :formKeys='searchFormKeys'
            ref='lySearchForm'
          ></ly-form>
          <div class='btn-group flex'>
            <el-button size='medium' @click='reset'>重置</el-button>
            <el-button type='primary' size='medium' @click='highSearch'>查询</el-button>
          </div>
        </div>
        <el-button slot='reference' size='medium' type='primary'>
          高级查询
          <i class='el-icon-arrow-down el-icon--right'></i>
        </el-button>
      </el-popover>
      <div class='fr'>
        <el-input
          v-model.trim='searchFormData.username'
          placeholder='请填写用户名'
          @keypress.enter.native='() => search()'
          @clear='search'
          clearable
        ></el-input>
        <el-input
          v-model.trim='searchFormData.real_name'
          placeholder='请填写真实姓名'
          @keypress.enter.native='() => search()'
          @clear='search'
          clearable
        ></el-input>
        <el-input
          v-model.trim='searchFormData.id_card_no'
          placeholder='请填写身份证号'
          @keypress.enter.native='() => search()'
          @clear='search'
          clearable
        ></el-input>
        <el-input
          v-model.trim='searchFormData.telephone'
          placeholder='请填写手机号'
          @keypress.enter.native='() => search()'
          @clear='search'
          clearable
        ></el-input>
        <el-button @click='() => search()' type='primary'>查询</el-button>
      </div>
    </div>
    <div class='ly-card'>
      <el-tabs v-model='activeContract' @tab-click='changeContractStatus'>
        <el-tab-pane label='全部' name='0'></el-tab-pane>
        <el-tab-pane v-for='item in contractStatus' :key='item.value' :name='`${item.value}`'>
          <span slot='label'>
            {{ item.label }}
            <i v-if='item.value === 3 && overdueLen' class='overdue-len'>（{{ overdueLen }}）</i>
          </span>
        </el-tab-pane>
      </el-tabs>
      <ly-table
        :getTableData='getTableData'
        :tableHeader='tableHeader'
        :tableConfig='tableConfig'
        :searchFormData='searchFormData'
        ref='lyTable'
        class='width-full'
      >
        <template v-slot:username='row'>
          <el-button type='text' size='mini' @click="showClass(row, 'base')">{{ row.username }}</el-button>
        </template>
        <template v-slot:age='row'>{{ row.age !== null ? `${ row.age }岁` : '一' }}</template>
        <template v-slot:contract_time='row'>{{
            row.contract_start_date ? `${ row.contract_start_date } 至 ${ row.contract_end_date }` : '一'
          }}
        </template>
        <template v-slot:org_full_names='row'>
          {{ row.org_full_names ? row.org_full_names.replace(/中国儿童中心\/+/, '') : '一' }}
        </template>
        <template v-slot:action='row'>
          <el-button @click="showClass(row, 'contract')" type='text' size='mini' v-if="hasPermission('contract_detail')">合同</el-button>
          <el-button @click='editRow(row)' type='text' size='mini'>修改</el-button>
          <el-button @click='delRow(row)' type='text' class='el-button--danger' size='mini'>移除</el-button>
        </template>
      </ly-table>
    </div>
    <set-table-header
      @close='dialogVisible = false'
      @change='setShowField'
      itemKey='teachermange'
      :dialogVisible='dialogVisible'
      :tableHeader='tableHeader'
    ></set-table-header>
    <el-dialog title='修改教师' :visible.sync='dialogTh' @opened='openEvent' width='880px'>
      <ly-form
        :defaultFormItem='defaultFormItem'
        :formConfig='formConfig'
        :formKeys='formKeys'
        class='ly-form'
        ref='lyForm'
      >
        <template v-slot:teacher_icon='{ formData }'>
          <img :src="formData.teacher_icon === 'default' ? IMG : `${baseUrl}/${formData.teacher_icon}`" width='100px' />
          <upload
            @successCBK="value => mediaChange('teacher_icon', value, formData)"
            accept='.jpg, .jpeg, .png, .gif, .bmp'
          />
        </template>
      </ly-form>
      <span slot='footer' class='dialog-footer'>
        <el-button @click='dialogTh = false'>取 消</el-button>
        <el-button type='primary' @click='addTeacher'>确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog title='教师信息' :visible.sync='dialogClass' width='90%' @closed='closedEvent'>
      <el-tabs v-model='activeName'>
        <el-tab-pane label='基础信息' name='base'>
          <ul class='teacher-base-info'>
            <li v-for='key in valueKeys' :key='key'>
              <div class='name'>{{ formKeys[key] ? formKeys[key].label : '' }}</div>
              <div class='value'>
                <img
                  v-if="key === 'teacher_icon'"
                  :src="
                    defaultFormItem[key] === 'default' || !defaultFormItem[key]
                      ? IMG
                      : `${baseUrl}/${defaultFormItem[key]}`
                  "
                  width='50px'
                />
                <span v-else>{{ defaultFormItem[`${ key }_label`] || defaultFormItem[key] || '无' }}</span>
              </div>
            </li>
          </ul>
        </el-tab-pane>
        <el-tab-pane label='教师班级' name='classes'>
          <el-button type='primary' class='m-b-15' size='medium' @click='exportTeachClassExcel'>导出</el-button>
          <ly-table
            :getTableData='getClassData'
            :tableHeader='tableHeaderClass'
            :searchFormData='classSearch'
            ref='lyTableClass'
            class='width-full diy-table'
          >
            <template v-slot:org='row'>
              {{ row.fee_level.org_full_name && row.fee_level.org_full_name.replace(/中国儿童中心\/+/, '') }}
            </template>
            <template v-slot:specialized='row'>
              {{ row.fee_level.specialized_subject_full_name }}
            </template>
            <template v-slot:teacher='row'>
              {{ row.teacher | teacherFilter }}
            </template>
            <template v-slot:class_time='row'>
              {{ `${ row.first_class_start_time.split(' ')[0] } 至 ${ row.last_class_end_time.split(' ')[0] }` }}
            </template>
            <template v-slot:fee='row'>{{ row.fee_level.name }}</template>
          </ly-table>
        </el-tab-pane>
        <el-tab-pane v-if="hasPermission('contract_detail')" label='合同信息' name='contract'>
          <el-button type='primary' class='m-b-10' @click='() => openDigFromContract()' v-if="hasPermission('contract_create')">新建合同</el-button>
          <ly-table
            :getTableData='getClassDataContract'
            :tableHeader='tableHeaderContract'
            :searchFormData='searchContract'
            ref='lyTableContract'
            class='width-full diy-table'
          >
            <template v-slot:contract_date='row'>
              {{ `${ row.contract_start_date } 至 ${ row.contract_end_date }` }}
            </template>
            <template v-slot:action='row'>
              <el-button size='mini' type='primary' @click='editContract(row)' v-if="hasPermission('contract_edit')">修改</el-button>
              <el-button size='mini' @click='continueContract(row )' v-if='hasPermission("contract_renew")'>续签</el-button>
              <el-button size='mini' type='danger' v-if='!row.is_invalid && hasPermission("contract_delete")' @click='cancerContract(row)'>作废</el-button>
            </template>
          </ly-table>
        </el-tab-pane>
      </el-tabs>
    </el-dialog>
    <el-dialog title='课程表' :visible.sync='dialogVisibleSc' width='1400px'>
      <class-schedule :class_mode='scTime.class_mode' :class_id='scTime.class_id' />
    </el-dialog>
    <el-dialog
      :title="`${isContinue ? '续签' : defaultFormItemContact.id ? '修改' : '新建'}合同`"
      :visible.sync='dialogVisibleContract'
      width='600px'
      @close='clearContract'
    >
      <ly-form
        :defaultFormItem='defaultFormItemContact'
        :formKeys='formKeysContract'
        :formConfig='formConfigContact'
        class='ly-form-contract'
        ref='lyFormContract'
      ></ly-form>
      <span slot='footer'>
        <el-button @click='dialogVisibleContract = false'>取 消</el-button>
        <el-button type='primary' @click='addContract' :loading='loading'>保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { Dialog, Popover, Tabs, TabPane, Input } from 'element-ui';
import LyTable from '@/components/LyTable';
import LyForm from '@/components/LyForm';
import SetTableHeader from '@/components/SetTableHeader';
import { teacherFormItem, teacherSearchFormItem, addContractFormItem } from '@/utils/formConfig';
import { teacherTable, contractTable } from '@/utils/tableHeader';
import { classBaseInf } from '@/utils/tableHeaderClass';
import { teacher, classApi } from '@/api';
import Upload from '@/components/Upload';
import ClassSchedule from '@/components/ClassSchedule';
import utils from '@/utils/utils';
import perMixin from '@/utils/perMixin';

const Decimal = require('decimal.js/decimal.js');
const IMG = require('@/assets/images/avt.png');

export default {
  name: 'Teacher',
  mixins: [perMixin],
  components: {
    LyTable,
    LyForm,
    ElInput: Input,
    SetTableHeader,
    ElDialog: Dialog,
    ElPopover: Popover,
    ElTabs: Tabs,
    ElTabPane: TabPane,
    Upload,
    ClassSchedule
  },
  data() {
    return {
      overdueLen: 0,
      activeContract: '0',
      activeName: 'base',
      tableHeader: teacherTable,
      searchFormData: {
        contract_status: '',
        username: '',
        real_name: '',
        id_card_no: '',
        telephone: ''
      },
      getTableData: teacher.getTeachers,
      dialogVisible: false,
      dialogTh: false,
      formKeys: {},
      defaultFormItem: {},
      formConfig: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 12
      },
      tableConfig: {
        action: {
          'selection-change': selection => {
            this.selection = selection;
          }
        }
      },
      searchFormConfig: {
        'label-width': '120px',
        'label-position': 'left',
        itemSpan: 12
      },
      searchFormKeys: {},
      searchVisible: false,
      baseUrl: '',
      dialogClass: false,
      classSearch: {},
      getClassData: classApi.getClassInf,
      tableHeaderClass: [],
      dialogVisibleSc: false,
      scTime: {}, // 课程表信息
      IMG,
      valueKeys: Object.keys(teacherFormItem),
      // 合同信息
      formConfigContact: {
        'label-width': '120px',
        'label-position': 'left',
        ref: 'ly-form',
        itemSpan: 24
      },
      dialogVisibleContract: false,
      getClassDataContract: teacher.getContract,
      tableHeaderContract: contractTable,
      searchContract: {
        user_id: ''
      },
      formKeysContract: {},
      defaultFormItemContact: {},
      loading: false,
      isContinue: false,
      contractStatus: [],
      contractType: [],
      selection: []
    };
  },
  mounted() {
    this.init();
    this.search();
    const classBaseInfTmp = window.cloneDeep(classBaseInf);
    classBaseInfTmp.forEach(item => {
      const tmp = item;
      if (item.option && item.option.width && item.value !== 'class_time') delete tmp.option.width;
    });
    this.tableHeaderClass = classBaseInfTmp;
    // 即将过期
    teacher
      .getTeachers({
        contract_status: 3,
        page_no: 1,
        page_size: 1
      })
      .then(res => {
        if (res && res.data) {
          this.overdueLen = res.data.total;
        }
      });
  },
  filters: {
    teacherFilter(value) {
      return (value || []).map(item => item.real_name).join(',');
    }
  },
  methods: {
    async init() {
      const resJobPro = teacher.jobTile();
      const resEduPro = teacher.education();
      const resStaPro = teacher.jobStatus();
      const resContractPro = teacher.contractStatus();
      const resContractType = teacher.contractType();
      const resContractStatus = teacher.contractStatus();
      const resJob = await resJobPro;
      const resEdu = await resEduPro;
      const resSta = await resStaPro;
      const resContract = await resContractPro;
      const contractType = await resContractType;
      const contractStatus = await resContractStatus;

      if (resJob) {
        teacherFormItem.job_title.options.select = resJob.data;
        teacherSearchFormItem.job_title.options.select = resJob.data;
      }
      if (resEdu) {
        teacherFormItem.education.options.select = resEdu.data;
        teacherSearchFormItem.education.options.select = resEdu.data;
      }
      if (resSta) {
        teacherFormItem.job_status.options.select = resSta.data;
        teacherSearchFormItem.job_status.options.select = resSta.data;
      }
      if (contractStatus) {
        teacherSearchFormItem.contract_status.options.select = contractStatus.data;
      }
      if (resContract) {
        this.contractStatus = resContract.data;
      }
      if (contractType) {
        const data = contractType.data.map(item => ({
          ...item,
          disabled: item.activate_status === false
        }));
        this.contractType = data;
        teacherSearchFormItem.contract_type.options.select = data;
      }
      this.formKeys = teacherFormItem;
      this.searchFormKeys = teacherSearchFormItem;

      this.baseUrl = await this.$store.dispatch('app/getOssUrl');
    },
    exportExcel(selection) {
      let params = {};
      if (selection) {
        params = {
          ...this.searchFormData,
          user_ids: selection.map(item => item.user_id)
        };
      } else {
        params = this.searchFormData;
      }
      teacher
        .exportTeacher({
          params
        })
        .then(data => {
          if (data) utils.downloadData(data, '教师列表');
        });
    },
    setShowField(data) {
      this.tableHeader = data;
    },
    openDigFrom(isAdd) {
      this.dialogTh = true;
      if (isAdd) {
        this.defaultFormItem = {
          teacher_icon: 'default'
        };
      }
    },
    mediaChange(key, value, formData) {
      if (value && value.length) {
        // eslint-disable-next-line no-param-reassign
        formData[key] = value[0].url;
      }
    },
    async addTeacher() {
      const { data, valid } = await this.$refs.lyForm.getFormData();
      if (valid) {
        let res = null;
        if (data.remuneration) data.remuneration = Decimal.div(data.remuneration, 100).toNumber();
        if (new Date(data.contract_start_date).getTime() > new Date(data.contract_end_date).getTime()) {
          this.$message.warning('合同结束日期要大于开始日期！');
          return;
        }
        if (this.defaultFormItem.teacher_id) {
          // 修改
          res = await teacher.controlTeacher({
            methold: 'put',
            id: this.defaultFormItem.teacher_id,
            params: data
          });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '修改成功');
        } else {
          // 新增
          res = await teacher.teacher({ params: { ...data, user_id: this.defaultFormItem.user_id }, methold: 'post' });
          if (res) this.$store.dispatch('msg/showMsg', res.msg || '新增成功');
        }
        if (res) {
          this.$refs.lyTable.setData();
          this.dialogTh = false;
        }
      }
    },
    delRow(row) {
      this.$confirm(`确认移除-${row.username}？`)
        .then(() => {
          teacher
            .teacher({
              methold: 'delete',
              params: row
            })
            .then(res => {
              if (res) {
                this.search();
                this.$store.dispatch('msg/showMsg', res.msg || '移除成功');
              }
            });
        })
        .catch(() => {
        });
    },
    editRow(row) {
      this.defaultFormItem = {
        ...row,
        remuneration: row.remuneration ? Decimal.mul(row.remuneration, 100).toNumber() : row.remuneration,
        teacher_icon: row.teacher_icon || 'default'
      };
      this.openDigFrom();
    },
    openEvent() {
      this.$refs.lyForm.$refs.lyForm.clearValidate();
    },
    // search() {
    //   this.$refs.lyTable.setData();
    // },
    // 拆分高级搜索
    search(data) {
      this.searchFormData = {
        ...this.searchFormData,
        ...data
      };
      this.$refs.lyTable.setData();
    },
    async highSearch() {
      const { data } = await this.$refs.lySearchForm.getFormData();
      if (data.contract_date && data.contract_date.length) {
        this.searchFormData = {
          ...data,
          contract_start_date: data.contract_date[0],
          contract_end_date: data.contract_date[1]
        };
      } else {
        this.searchFormData = { ...data };
      }
      this.search();
      this.searchVisible = false;
    },
    showClass(row, activeName) {
      this.activeName = activeName;

      this.dialogClass = true;
      this.classSearch = { user_id: row.user_id };
      this.defaultFormItem = { ...row };
      this.searchContract.user_id = row.user_id;
      this.$nextTick(() => {
        this.$refs.lyTableClass.setData();
        this.searchContractTable();
      });
    },
    searchContractTable() {
      this.$refs.lyTableContract.setData();
    },
    closedEvent() {
      this.$refs.lyTableClass.clearData();
    },
    showSc(row) {
      this.dialogVisibleSc = true;
      this.scTime = {
        class_mode: row.class_mode,
        class_id: row.id
      };
    },
    async openDigFromContract(row, isContinue) {
      if (!row) this.defaultFormItemContact = {};
      this.isContinue = !!isContinue;
      addContractFormItem.contract_type.options.select = this.contractType;
      this.formKeysContract = addContractFormItem;
      this.dialogVisibleContract = true;
    },
    async addContract() {
      const { valid, data } = await this.$refs.lyFormContract.getFormData();
      if (!valid) return;
      this.loading = true;
      let res = null;
      const params = {
        contract_type: data.contract_type,
        contract_start_date: data.contract_date[0],
        contract_end_date: data.contract_date[1]
      };
      if (this.isContinue) {
        // 续签
        res = await teacher.controlContract({
          params,
          teacher_contract_record_id: this.defaultFormItemContact.id,
          methold: 'post'
        });
      } else if (this.defaultFormItemContact.id) {
        // 修改
        res = await teacher.controlContract({
          params,
          teacher_contract_record_id: this.defaultFormItemContact.id,
          methold: 'put'
        });
      } else {
        // 保存
        res = await teacher.addContract({
          params,
          user_id: this.defaultFormItem.user_id,
          methold: 'post'
        });
      }

      if (res) {
        this.$message.success(res.msg || '新建合同成功！');
        this.dialogVisibleContract = false;
        this.searchContractTable();
      }
      this.loading = false;
      this.search();
    },
    clearContract() {
      this.$refs.lyFormContract.resetFields();
    },
    editContract(row) {
      this.defaultFormItemContact = {
        ...row,
        contract_date: [row.contract_start_date, row.contract_end_date]
      };
      this.openDigFromContract(row);
    },
    continueContract(row) {
      this.defaultFormItemContact = {
        id: row.id
      };
      this.openDigFromContract(row, true);
    },
    cancerContract(row) {
      // 作废
      this.$confirm('确认作废合同?', '提示', {
        type: 'warning'
      })
        .then(() => {
          teacher
            .controlContract({
              teacher_contract_record_id: row.id,
              methold: 'patch'
            })
            .then(res => {
              if (res) {
                this.$message.success(res.msg || '作废成功！');
                this.searchContractTable();
              }
            });
        })
        .catch(() => {
        });
    },
    changeContractStatus() {
      if (this.activeContract === '0') this.searchFormData.contract_status = '';
      else this.searchFormData.contract_status = this.activeContract;
      this.search();
    },
    reset() {
      this.$refs.lySearchForm.resetFields();
      this.searchFormData = {};
      this.search();
    },
    exportTeachClassExcel() {
      classApi
        .exportClassInfo({
          params: {
            user_id: this.defaultFormItem.user_id
          }
        })
        .then(data => {
          if (data) utils.downloadData(data, `教师${this.defaultFormItem.real_name}班级列表`);
        });
    }
  }
};
</script>

<style lang='less'>
.teacher {
  .ly-form {
    .el-input,
    .el-textarea {
      width: 212px;
    }
  }

  .ly-form .width-full .el-input {
    width: 630px;
  }

  .overdue-len {
    font-style: normal;
    color: @danger;
  }
}

.high-search {
  .ly-form {
    .el-input {
      width: 212px;
    }
  }
}

.ly-form-contract {
  .el-select .el-input {
    width: 350px;
  }
}

.teacher-base-info {
  padding-left: 0;

  li {
    display: flex;
    margin: 15px 0;
    font-size: 14px;

    .name {
      font-weight: 700;
      min-width: 120px;
    }
  }
}

.fr {
  .el-input {
    width: 200px;
    margin-right: 20px;
  }
}
</style>
